const CRITERION_LABELS: Record<string, string> = {
  // new endpoint (snake_case)
  distance: "Distância",
  min_capacity: "Capacidade mínima",
  max_capacity: "Capacidade máxima",
  min_price: "Preço mínimo",
  max_price: "Preço máximo",
  amenities: "Amenidades obrigatórias",
  amenities_optional: "Amenidades opcionais",
  // old endpoint (PascalCase)
  Capacity: "Capacidade",
  Price: "Preço",
  Proximity: "Proximidade",
  "Required Amenities": "Amenidades obrigatórias",
  "Optional Amenities": "Amenidades opcionais",
};

export function translateCriterion(criterion: string): string {
  return CRITERION_LABELS[criterion] ?? criterion;
}
